import React, { useCallback, useMemo } from 'react';
import { Criterion, MultipleChoiceField, Quota } from 'queries';
import { LogicJumpOption } from '../elements/interface';
import { ScreeningFormMinMax } from 'components/CustomForm/FormBuilder/elements/ScreeningFormMinMax';
import { SelectChoiceBuilder } from 'components/CustomForm/FormBuilder/Fields/SelectChoiceBuilder';

interface Props {
  field: MultipleChoiceField;
  onChange: (field: MultipleChoiceField) => any;
  criterion?: Criterion;
  onCriterionChange?: (criterion: Criterion) => any;
  logicJumpOptions?: LogicJumpOption[];
  mustChooseValidation?: boolean;
  numberOfParticipantRequired?: number;
  sessionId?: string;
  quotas?: Quota[];
  onQuotaChange?: (quotas: Quota[]) => void;
}

export const MultipleChoiceBuilder = ({
  field,
  onChange,
  criterion,
  onCriterionChange,
  logicJumpOptions,
  mustChooseValidation,
  numberOfParticipantRequired,
  sessionId,
  quotas,
  onQuotaChange,
}: Props) => {
  const _onCriterionChange = useCallback(
    (newCriterion: Criterion) => {
      if (onCriterionChange) {
        onCriterionChange({
          ...newCriterion,
          quotas: null,
        });
      }
    },
    [onCriterionChange],
  );

  return (
    <SelectChoiceBuilder<MultipleChoiceField>
      field={field}
      onChange={onChange}
      criterion={criterion}
      quotas={quotas}
      onChangeQuota={onQuotaChange}
      onCriterionChange={_onCriterionChange}
      logicJumpOptions={logicJumpOptions}
      mustChooseValidation={mustChooseValidation}
      enabledTolerate
      sessionId={sessionId}
      numberOfParticipantRequired={numberOfParticipantRequired}
    >
      <ScreeningFormMinMax field={field} onChange={onChange} />
    </SelectChoiceBuilder>
  );
};
